import {
    TextInput,
    required,
    DateInput,
    usePermissions,
    useResourceContext,
    useTranslate,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { SimpleFormWithPermissions } from "../components/SimpleFormWithPermissions";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaEditView } from "../components/views/RaEditView";
import { endDateNotBeforeStartDate } from "./validateRentalDates";

export const RentalEdit = (props) => {
    const translate = useTranslate();
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }

    return (
        <RaEditView
            {...props}
            mutationMode="pessimistic"
            actions={<ToolbarWithHistory back={true} show={true} delete={true} />}
        >
            <SimpleFormWithPermissions redirect="show">
                <TextInput
                    title={translate("equip.name")}
                    label="equip.name"
                    source="name"
                    validate={[required()]}
                />
                <DateInput
                    title={translate("equip.startDate")}
                    label="equip.startDate"
                    source="startDate"
                    validate={[required()]}
                />
                <DateInput
                    title={translate("equip.endDate")}
                    label="equip.endDate"
                    source="endDate"
                    validate={[required(), endDateNotBeforeStartDate]}
                />
            </SimpleFormWithPermissions>
        </RaEditView>
    );
};
